import { useState } from "react";
import { IconButton, Dialog, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import "./component.scss";
import RegexInstructions from "./regex_instructions";
import NoData from "./no_data";
import Header from "./header";
import { useSearch } from "./hooks";
import SearchResults from "./search_results";

const GlobalSearch = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const {
    searchText,
    regexSearch,
    setRegexSearch,
    highlight,
    isApiStartedCalling,
    resultAvailable,
    invalidRegex,
    searchFieldRef,
    handleSearchChange,
    handleClear,
    headersInfo,
    onScroll,
    onViewAllHandler,
    selected_tab,
    isScrollOn,
    onTabClear,
    onTabSelection,
  } = useSearch();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton sx={{ "&:focus": { outline: "none" } }} onClick={handleOpen}>
        <SearchIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        sx={{
          "& .MuiPaper-root": {
            width: "70% !important",
            padding: "16px 0px !important",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CancelIcon />
        </IconButton>
        <div className={`search-container scroll ${theme.palette.mode === 'dark' ? 'dark-theme' : ''}`}>
          <Header
            regexSearch={regexSearch}
            setRegexSearch={setRegexSearch}
            searchText={searchText}
            handleSearchChange={handleSearchChange}
            ref={searchFieldRef}
            highlight={highlight}
            handleClear={handleClear}
          />
          <div className="search-results">
            <NoData
              regexSearch={regexSearch}
              resultAvailable={resultAvailable}
              searchText={searchText}
              invalidRegex={invalidRegex}
              isApiStartedCalling={isApiStartedCalling}
            />
            <RegexInstructions
              regexSearch={regexSearch}
              isApiStartedCalling={isApiStartedCalling}
              invalidRegex={invalidRegex}
              searchText={searchText}
            />
            <SearchResults
              headersInfo={headersInfo}
              isApiStartedCalling={isApiStartedCalling}
              resultAvailable={resultAvailable}
              onTabSelection={onTabSelection}
              clearSelection={onTabClear}
              onScroll={onScroll}
              onViewAllHandler={onViewAllHandler}
              selectedTab={selected_tab}
              isScrollOn={isScrollOn}
              handleClose={handleClose}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default GlobalSearch;
